import React from "react";
import about_img from "../../assets/icons/edu_symb_1-01.png";
// import award_1 from "../../assets/icons/awardicon1.png";
// import award_2 from "../../assets/icons/awardicon2.png";
// import award_3 from "../../assets/icons/awardicon3.png";
// import CheckIcon from "@mui/icons-material/Check";
const HomeAbout = () => {
  return (
    <div className=" md:py-10 xl:py-20  py-16 relative" id="about-us">
      <div className="lg:top-1 bottom-5 absolute right-2 ">
        <img
          src={about_img}
          alt="about our education "
          className="lg:w-80 w-48"
        />
      </div>
      <div className="flex flex-col justify-center ">
        <p className="font-teacher text-base sm:pb-5 pb-0 text-[#005064] font-bold tracking-[4px] uppercase">
          About Our Society
        </p>
        <h2
          className="xl:text-5xl sm:text-4xl text-3xl font-semibold  py-4 text-[#1a1a1a]"
          style={{
            lineHeight: "1.2em",
          }}
        >
          Sri Laxmi Narasimha Educational Society 
        </h2>
        <p className=" text-base sm:py-5 py-3 text-[#1a1a1a]">
          Sri Laxmi Narasimha Educational Society is founded by a group of young
          and dynamic enterpreneurs with an ambition to start educational
          institutions which can focus on future needed skills for the
          generations to come and where the students can master technology as a
          powerful creative tool for attaining global connection and expression.
        </p>
        <p className=" text-base  text-[#1a1a1a] ">
          The vision of the society is a world where education should be
          crafting, not sorting mechanism. The Society wish to build a sanctum
          where learning is driven by wonder rather than the anxiety of
          assessments, and where every child feels seen for who they are, not
          just how they perform.
        </p>
        <p className=" text-base sm:py-5 py-3 text-[#1a1a1a] ">
          The Society also believes in compassion & character from where
          everything else grows.... brilliant minds without a moral compass are
          unsafe. The Society is committed to inspire the student community to
          weave into daily life that values kindness, integrity and courage
          which caters to intellectual achievement.
        </p>
      </div>
    </div>
  );
};

export default HomeAbout;
